import { render, staticRenderFns } from "./TryHosting.vue?vue&type=template&id=1459da60&scoped=true&"
import script from "./TryHosting.vue?vue&type=script&lang=js&"
export * from "./TryHosting.vue?vue&type=script&lang=js&"
import style0 from "./TryHosting.vue?vue&type=style&index=0&id=1459da60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459da60",
  null
  
)

export default component.exports